import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import api from "./services/api";
import authSlice from "./services/slices/authSlice";
import { chatApi } from "./services/chat";
import { chatSessionMiddleware, chatSessionReducer } from "./services/chatSession";

export const createAppStore = () => configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    chatSession: chatSessionReducer,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, chatSessionMiddleware, chatApi.middleware),
});

export const store = createAppStore();

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
